export const GET_ALL_SKILLS = 'get_all_skills';
export const GET_ALL_SKILLS_SUCCESS = 'get_all_skills_success';
export const ADD_SKILL = 'add_skill';
export const EDIT_SKILL = 'edit_skill';
export const DELETE_SKILL = 'delete_skill';
export const GET_SKILL_DETAIL = 'get_skill_detail';
export const GET_SKILL_DETAIL_SUCCESS = 'get_skill_detail_success';
